import { DatePicker, Form, Input, Modal, Select, message } from "antd";
import * as React from "react";
import { addDonateRecord, getDonateRecordForm } from "../api/api";
import { AnyType } from "../util/types";
import moment from "moment";

interface DonateAddModalProp {
  gid: string | number;
  onFinish: (f: boolean) => void;
  open: boolean;
}

const DonateAddModal: React.FunctionComponent<DonateAddModalProp> = ({
  gid,
  onFinish,
  open,
}) => {
  const [users, setUsers] = React.useState([]);
  const [types, setTypes] = React.useState([]);

  const [form] = Form.useForm();

  const agetList = async () => {
    const ret = await getDonateRecordForm(`${gid}`);
    const { groupMemberList, donateTypeList, idAndUserMap } = ret;

    const ausers = groupMemberList.map((x: AnyType) => {
      const auser = idAndUserMap[x.userId];
      const { id, ...rest } = auser;
      return { ...x, ...rest };
    });
    setUsers(ausers);
    setTypes(donateTypeList);
  };

  React.useEffect(() => {
    agetList();
  }, []);

  const okHandler = async () => {
    form.validateFields().then(async (params) => {
      params.happenDate = moment(params.happenDate).format("YYYY-MM-DD");
      params.groupId = `${gid}`;
      const ret = await addDonateRecord(params);
      message.success("添加成功");
      onFinish(true);
    });
  };

  return (
    <Modal
      closable
      width={450}
      open={open}
      onCancel={() => onFinish(false)}
      onOk={okHandler}
      title="添加记录"
    >
      <Form form={form} labelCol={{ span: 6 }}>
        <Form.Item name="userId" label="用户" rules={[{ required: true }]}>
          <Select>
            {users.map((x: AnyType) => (
              <Select.Option key={x.userId}>{x.nickName}</Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item name="donateType" label="类型" rules={[{ required: true }]}>
          <Select>
            {types.map((x: AnyType) => (
              <Select.Option key={x.code}>{x.msg}</Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          name="remainAmount"
          label="金额"
          rules={[{ required: true }]}
        >
          <Input type="number" />
        </Form.Item>
        <Form.Item name="happenDate" label="日期" rules={[{ required: true }]}>
          <DatePicker />
        </Form.Item>
        <Form.Item name="description" label="备注">
          <Input.TextArea rows={3} />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default DonateAddModal;
